import { useSearchParams } from "react-router-dom";
import { useEffectOnceWhen } from "rooks";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { commitmentsDatesSelector } from "@/store/commitments/selectors/common/view-options/commitmentsDatesSelector";
import {
  setCommitmentsDetailsDrawerDates,
  setCommitmentsDetailsRequestData,
} from "@/store/commitments/commitmentsSlice";

export const commitmentIdForDrawerSearchParam =
  "commitmentIdForDrawerSearchParam";
export const providerIdForDrawerSearchParam = "providerIdForDrawerSearchParam";

export const useCommitmentDrawerOpener = () => {
  const dispatch = useAppDispatch();
  const dates = useAppSelector(commitmentsDatesSelector);

  const [searchParams, setSearchParams] = useSearchParams();
  const commitmentId = searchParams.get(commitmentIdForDrawerSearchParam);
  const providerId = searchParams.get(providerIdForDrawerSearchParam);

  useEffectOnceWhen(
    () => {
      if (!providerId || !commitmentId) {
        return;
      }

      dispatch(setCommitmentsDetailsDrawerDates(dates));
      dispatch(
        setCommitmentsDetailsRequestData({
          targetType: "commitment",
          targetId: providerId,
          commitmentId: commitmentId,
        }),
      );

      searchParams.delete(commitmentIdForDrawerSearchParam);
      searchParams.delete(providerIdForDrawerSearchParam);
      setSearchParams(searchParams);
    },
    !!(commitmentId && providerId),
  );
};
